import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceCheckPoint } from 'app/models/check-point.model';
import { InterfaceEmployee } from 'app/models/employee.model';
import { InterfaceJob } from 'app/models/job.model';
import { EmployeeService } from 'app/services/employee.service';
import { SweetalertService } from 'app/services/sweetalert.service';
import { timezone } from 'assets/constants/timezone';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
import * as isoWeek from 'dayjs/plugin/isoWeek';
import * as dayOfYear from 'dayjs/plugin/dayOfYear';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);
dayjs.extend(isoWeek);
dayjs.extend(dayOfYear);

@Component({
  selector: 'app-do-check-point',
  templateUrl: './do-check-point.component.html',
  styleUrls: ['./do-check-point.component.scss']
})
export class DoCheckPointComponent implements OnInit {

  isSaving = false;
  @Input() user: InterfaceEmployee;
  @Input() job: InterfaceJob;
  @Input() checkPoint: InterfaceCheckPoint;
  @Input() employee: InterfaceEmployee;
  @Input() role: string;
  formCheckPoint = new FormGroup({
    comments: new FormControl(null, Validators.required)
  });

  constructor(
    public ngbActiveModal: NgbActiveModal,
    protected employeeService: EmployeeService,
    public swal: SweetalertService
  ) { }

  ngOnInit(): void {
  }

  save(): void {
    this.isSaving = true;
    switch (this.role) {
      case "Employee":
        const newCheckPointData = {
          ...this.formCheckPoint.value,
          id: this.employeeService.createId(),
          employeeId: this.user.id,
          jobId: this.job.id,
          checkPointId: this.checkPoint.id,
          supervisorId: this.job.supervisorId,
          auditorId: this.job.auditorId,
          createdAt: dayjs().tz(timezone).unix(),
          year: dayjs().tz(timezone).year(),
          type: this.checkPoint.period,
          dayMonth: dayjs().tz(timezone).date(),
          dayInYear: dayjs().tz(timezone).dayOfYear(),
          week: dayjs().tz(timezone).isoWeek(),
          biweek: Number(dayjs().tz(timezone).year() + "" + (dayjs().tz(timezone).month() + 1) + "" + (Number(dayjs().tz(timezone).date()) > 15 ? 30 : 15)),
          month: dayjs().tz(timezone).get("month") + 1
        };
        this.employeeService.doCheckPointEmployee(newCheckPointData).then(() => {
          this.swal.showSuccess();
          this.ngbActiveModal.close({
            success: true
          });
        }).catch((error: any) => {
          console.error(error);
          this.swal.showError();
          this.ngbActiveModal.close({
            success: false,
            error
          });
        });
        break;
      case "Supervisor":
        const newCheckPointSupervisor = {
          ...this.formCheckPoint.value,
          id: this.employeeService.createId(),
          employeeId: this.employee.id,
          jobId: this.job.id,
          checkPointId: this.checkPoint.id,
          supervisorId: this.user.id,
          auditorId: this.job.auditorId,
          createdAt: dayjs().tz(timezone).unix(),
          year: dayjs().tz(timezone).year(),
          type: this.checkPoint.period,
          dayMonth: dayjs().tz(timezone).date(),
          dayInYear: dayjs().tz(timezone).dayOfYear(),
          week: dayjs().tz(timezone).isoWeek(),
          biweek: Number(dayjs().tz(timezone).year() + "" + (dayjs().tz(timezone).month() + 1) + "" + (Number(dayjs().tz(timezone).date()) > 15 ? 30 : 15)),
          month: dayjs().tz(timezone).get("month") + 1
        };
        this.employeeService.doCheckPointSupervisor(newCheckPointSupervisor).then(() => {
          this.swal.showSuccess();
          this.ngbActiveModal.close({
            success: true
          });
        }).catch((error: any) => {
          console.error(error);
          this.swal.showError();
          this.ngbActiveModal.close({
            success: false,
            error
          });
        });
        break;
      case "Auditor":
        const newCheckPointAuditor = {
          ...this.formCheckPoint.value,
          id: this.employeeService.createId(),
          employeeId: this.employee.id,
          jobId: this.job.id,
          checkPointId: this.checkPoint.id,
          supervisorId: this.job.supervisorId,
          auditorId: this.user.id,
          createdAt: dayjs().tz(timezone).unix(),
          year: dayjs().tz(timezone).year(),
          type: this.checkPoint.period,
          dayMonth: dayjs().tz(timezone).date(),
          dayInYear: dayjs().tz(timezone).dayOfYear(),
          week: dayjs().tz(timezone).isoWeek(),
          biweek: Number(dayjs().tz(timezone).year() + "" + (dayjs().tz(timezone).month() + 1) + "" + (Number(dayjs().tz(timezone).date()) > 15 ? 30 : 15)),
          month: dayjs().tz(timezone).get("month") + 1
        };
        this.employeeService.doCheckPointAuditor(newCheckPointAuditor).then(() => {
          this.swal.showSuccess();
          this.ngbActiveModal.close({
            success: true
          });
        }).catch((error: any) => {
          console.error(error);
          this.swal.showError();
          this.ngbActiveModal.close({
            success: false,
            error
          });
        });
        break;
      case "Default":
        console.error("No user role found");
        break;
    }
  }

}
